import React, { useEffect, useState } from 'react'
import DynamicActionBar from '../../Common/DynamicActionBar'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ACTIONS } from '../../redux/actions'
import { HeadersPath } from '../../Utils/ScreenPath'
import { ErrorToast } from '../../Common/Toast'
import { Api } from '../../Service/api'
import { SubscriptionBox } from '../../Component/PaperHistory/SubscriptionBox'
import { NotDataFound } from '../NotFound'
import QuestionReportModel from '../../Common/QuestionReport'

const ReportedQuestions = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const loader = useSelector((state) => state?.Loader?.Loader);
    const [subjectPurchase, setSubjectPurchase] = useState([])

    const handleBackClick = () => {
        navigate(-1)
    }

    const _getSubjectPurchase = async () => {
        dispatch(ACTIONS.startLoading())
        try {
            let params = {
                limit: 1000,
                offset: 1
            }
            const { data } = await Api.getSubjectPurchase(params)
            const res = JSON.parse(data)
            if (res?.status === 200) {
                setSubjectPurchase(res?.data)
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }

    useEffect(() => {
        _getSubjectPurchase()
        dispatch(ACTIONS.getHeaderPath(HeadersPath.Profile))
    }, [])

    return (
        <div>
            <DynamicActionBar
                showArrowLeft
                backButtonLabel={"Purchase Subject History"}
                onBackClick={handleBackClick}
            />

            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 py-4">
                {subjectPurchase.map(subscription => (
                    <SubscriptionBox key={subscription.id} subscription={subscription} />
                ))}
            </div>
            {subjectPurchase.length === 0 && loader === false && (
                NotDataFound("No History Found")
            )}
        </div>
    )
}

export default ReportedQuestions